import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import { Button } from "reactstrap";
import functions from "../Tienda/functions/functions";

import { CartContext } from "../Tienda/components/ParadigmaCartProvider";
import { ImagesCarousel, OfertaLabel } from './ImagesCarousel';

import { GlobalConfigTienda } from '../TiendaConfig';

import './styles.scss';

const CUOTAS = 6;

const toSentenceCase = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/(^|\s|\(|\/|-)([a-záéíóúñ])/g, (_, sep, ch) => sep + ch.toUpperCase());
};

const getPrecio = (ofertaPeriodo, ofertaCantidad, superoferta, articulo) => {
  if (superoferta && !ofertaPeriodo && !ofertaCantidad) return articulo.PrecioSuperOferta;
  if (ofertaCantidad && !superoferta) return articulo.OfertaNxM_Precio;
  return articulo.Precio;
};

const ProductoBox = ({ articulo, maxQuantity }) => {
  const cartContext = useContext(CartContext);
  if (!articulo) return null;

  const ofertaPeriodo = (
    articulo.OfertaPeriodo_FechaDesde != null &&
    articulo.OfertaPeriodo_FechaHasta != null &&
    Date.parse(articulo.OfertaPeriodo_FechaHasta) >= Date.now()
  );
  const ofertaCantidad = articulo.OfertaNxM_Cantidad > 0;
  const superoferta = articulo.DescuentoSuperOferta > 0;

  const precio = getPrecio(ofertaPeriodo, ofertaCantidad, superoferta, articulo);
  const sinPrecio = articulo.Precio == null || articulo.Precio === "Sin precio" || articulo.Precio <= 0;
  const precioLista = !sinPrecio ? functions.FormatPrice(precio, GlobalConfigTienda.NumeroDecimales) : null;
  const valorCuota = (!sinPrecio && precio > 0)
    ? functions.FormatPrice(precio / CUOTAS, GlobalConfigTienda.NumeroDecimales)
    : null;

  const cartItem = { code: articulo.code, talle_id: null, color_id: null };
  const maxQuantityAllowed = (maxQuantity && maxQuantity > 0) ? maxQuantity : articulo.maxQuantity;
  const yaEnCarrito = cartContext.isItemPresent(cartItem);
  const sinStock = yaEnCarrito && cartContext.getCantidadItem(cartItem) >= maxQuantityAllowed;

  return (
    <div className="rango-producto-box">
      <div className="rango-producto-box__media">
        <OfertaLabel
          ofertaPeriodo={ofertaPeriodo}
          ofertaCantidad={ofertaCantidad}
          superoferta={superoferta}
          DescuentoSuperOferta={articulo.DescuentoSuperOferta}
        />
        <ImagesCarousel
          articulo={articulo}
          ofertaPeriodo={ofertaPeriodo}
          ofertaCantidad={ofertaCantidad}
          superoferta={superoferta}
        />
      </div>
      <div className="rango-producto-box__body">
        <Link
          to={`/tienda/producto/${articulo.code}/`}
          className="rango-producto-box__title-link"
        >
          <h3 className="rango-producto-box__title">{toSentenceCase(articulo.Titulo)}</h3>
        </Link>

        {!sinPrecio ? (
          <div className="rango-producto-box__price-block">
            <div className="rango-producto-box__price">$ {precioLista}</div>
            {valorCuota && (
              <div className="rango-producto-box__cuotas">
                <i className="fa fa-credit-card" aria-hidden="true"></i>
                <span>{CUOTAS} cuotas sin interés de <strong>$ {valorCuota}</strong></span>
              </div>
            )}
          </div>
        ) : (
          <div className="rango-producto-box__price-block">
            <div className="rango-producto-box__sin-precio">Consultar precio</div>
          </div>
        )}

        <Button
          color="success"
          className="rango-producto-box__cta"
          disabled={sinPrecio || sinStock}
          onClick={() => cartContext.setItem({ ...cartItem, quantity: 1 })}
        >
          <i className={`fa ${yaEnCarrito ? "fa-cart-arrow-down" : "fa-shopping-cart"} mr-2`} aria-hidden="true"></i>
          {sinPrecio ? "No disponible" : (yaEnCarrito ? "Agregar otra" : "Agregar al carrito")}
        </Button>
      </div>
    </div>
  );
};

export default ProductoBox;
